import React, { Component } from 'react';

import UnityModal from '../UnityModal/UnityModal';
import UnityNotificationsHandler from './UnityNotificationsHandler';

export default class UnityNotificationsModal extends Component {
  render() {
    const { notifications = {}, ...modalProps } = this.props;
    const { target, ...notificationHandlerProps } = notifications;

    if (!target) return <UnityModal {...modalProps} />;

    return (
      <UnityNotificationsHandler target={target || 'no-target-specified'} {...notificationHandlerProps}>
        <UnityModal {...modalProps} />
      </UnityNotificationsHandler>
    );
  }
}